<pdq-card variant="flat" color="white" [formGroup]="orderEditingService.form.get('template.periods')">
  <div class="card-container">
    <div class="card-header">
      <pdq-heading element="h6">Order edit window</pdq-heading>
      <pdq-tag variant="success"
        >{{ orderEditingService.form.get('template.periods.value').value }}
        {{ capitalize(orderEditingService.form.get('template.periods.type').value) }}</pdq-tag
      >
    </div>
    <p class="body-14-regular">
      Set how long customers can make changes to their order post checkout. Orders can’t be edited once marked as
      ‘fulfilled’ in Shopify.
    </p>
    <pdq-divider></pdq-divider>
    <div class="card-body">
      <div class="edit-window-duration-container">
        <p>Edit time limit</p>

        <div class="edit-window-duration">
          <div class="edit-window-duration__input">
            <pdq-input type="number" formControlName="value" width="100"></pdq-input>
            <pdq-dropdown
              width="170"
              (onChange)="onTimeUnitChange($event)"
              [dirty]="orderEditingService.form.get('template.periods.type').dirty"
              [defaultOption]="
                orderEditingService.form.get('template.periods.type').value | primitiveDropdownOptionPipe: capitalize
              "
              [options]="timeUnitOptions"></pdq-dropdown>
          </div>
          @if (orderEditingService.form.get('template.periods').invalid) {
            <p class="inline-error body-12-regular">* Please enter a valid time between 5–59 minutes or 1–24 hours</p>
          }
        </div>
      </div>
      <pdq-slide-toggle
        formControlName="extendOnNonBusinessDays"
        togglePosition="right"
        label="Extend for weekends & holidays"
        subtext="If enabled, orders placed on weekends or holidays will be editable for the window duration into the next business day."></pdq-slide-toggle>
    </div>
  </div>
</pdq-card>
<pdq-card variant="flat" color="white" [formGroup]="orderEditingService.form.get('template.settings.discountCodes')">
  <div class="card-container">
    <div class="card-header">
      <pdq-heading element="h6">Discount Code Settings</pdq-heading>
    </div>
    <p class="section-description body-14-regular">
      Configure how discount codes are handled when customers edit their orders.
    </p>
    <pdq-divider></pdq-divider>
    <div class="card-body">
      <pdq-slide-toggle
        formControlName="recalculateEligibility"
        togglePosition="right"
        label="Keep discounts in sync with order edits"
        subtext="Keeps discounts accurate as customers edit: new items get their checkout discounts, and codes that stop qualifying are removed."></pdq-slide-toggle>
      @if (orderEditingService.form.get('template.settings.discountCodes.recalculateEligibility').value) {
        <div class="discount-removed-message">
          <pdq-input formControlName="discountRemovedMessage" label="Discount removed message"></pdq-input>
          <p class="body-12-regular input-subtext">
            This message is shown to customers when their discount is removed.
          </p>
        </div>
      }
    </div>
  </div>
</pdq-card>
<pdq-card variant="flat" color="white" [formGroup]="orderEditingService.form.get('template.settings')">
  <div class="card-container">
    <pdq-collapsed #flowsCollapsed [initialCollapsed]="false" id="order-editing-flows" [cacheState]="true">
      <pdq-collapsed-header>
        <div class="card-header" [class.collapsed]="flowsCollapsed.collapsed">
          <pdq-heading element="h6">Shopify Logic</pdq-heading>
          <pdq-collapsed-trigger [class.collapsed]="flowsCollapsed.collapsed">
            <pdq-icon icon="arrow_down" color="var(--on-surface-light)"></pdq-icon>
          </pdq-collapsed-trigger>
        </div>
      </pdq-collapsed-header>
      <pdq-collapsed-content>
        <pdq-divider></pdq-divider>
        <div class="card-body">
          <pdq-slide-toggle
            formControlName="useShopifyFlows"
            togglePosition="right"
            subtext="Use the Shopify Flow automations you’ve already set up"
            label="Follow Shopify Flow"></pdq-slide-toggle></div
      ></pdq-collapsed-content>
    </pdq-collapsed>
  </div>
</pdq-card>
